import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { AccountingEventClient, Feature } from 'src/WebApiController';

export const ACCOUNTING_EVENT_LAST_REFRESH_TIME_QUERY_KEY =
  'AccountingEventClient.getLastRefreshTime';

export function useAccountingEventLastRefreshTime(stream: string | undefined) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  const hasAccountingFeedUIFeature = useUserHasFeature(
    Feature.AccountingFeedUI
  );

  const shouldQuery =
    hasAccountingFeedUIFeature &&
    !!activeAccountWebClientConfig?.activeAccountId &&
    !!stream;

  return useQuery({
    queryKey: [
      ACCOUNTING_EVENT_LAST_REFRESH_TIME_QUERY_KEY,
      activeAccountWebClientConfig?.activeAccountId,
      stream,
    ],
    async queryFn(): Promise<string | null> {
      if (!shouldQuery) return null;

      const client = new AccountingEventClient(activeAccountWebClientConfig);
      try {
        return await client.getLastRefreshTime(stream);
      } catch (err) {
        trackError('AccountingEventClient.getLastRefreshTime', err as Error, {
          stream,
        });
        throw err;
      }
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
  });
}
